import React from 'react'
import styled from 'styled-components'

const CheckboxContainer = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: middle;
`

const Icon = styled.svg`
  fill: none;
  stroke: #2E5F62;
  stroke-width: 3px;
`
// Hide checkbox visually but remain accessible to screen readers.
const HiddenCheckbox = styled.input.attrs({
  type: 'checkbox',
  required: true

})`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  top: 10px;
`

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 3px;
  transition: all 150ms;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.3);
  cursor: pointer;
  border: solid 1px white;



  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }
`

const Checkbox = ({ className, checked, ...props }) => (
  <CheckboxContainer className={className}>
    <HiddenCheckbox
      checked={checked} {...props}
      onInvalid={(e) => e.target.setCustomValidity('Please read the terms and accept before proceeding')}
      onInput={(e) => e.target.setCustomValidity('')}

    />
    <StyledCheckbox checked={checked}>
      <Icon viewBox='0 0 24 24'>
        <polyline points='20 6 9 17 4 12' />
      </Icon>
    </StyledCheckbox>
  </CheckboxContainer>
)

export const AgreementContainer = styled.div`

  input {
    margin-right: 20px;
  }

  label {
    display:flex;
    span {
    font-size: 13px;
    color: black;

    a,
    a:visited {
      color: #3a6669;
    }
  }
  }


`

class AgreementCheckbox extends React.Component {
  state = { checked: false }

  handleCheckboxChange = event => {
    this.setState({ checked: event.target.checked })
  }

  render () {
    return (
      <AgreementContainer>

        <label>
          <Checkbox
            checked={this.state.checked}
            onChange={this.handleCheckboxChange}
          />
          <span style={{ marginLeft: 10 }}>

        I agree to Suki's &nbsp;
            <a href='https://www.suki.ai/legal/tsa/' target='_blank' rel='noopener noreferrer'>
        Technology Services Agreement
            </a>
      , including the &nbsp;

            <a href='https://www.suki.ai/legal/tsa#baa' target='_blank' rel='noopener noreferrer'>
        Business Associate Agreement
            </a>

          </span>
        </label>
      </AgreementContainer>

    )
  }
}

export default AgreementCheckbox
